import React from "react";
import { withStyles } from "@material-ui/core/styles";
import qs from "qs";

import ApiTour from "../../../API/ApiTour";
import ApiUser from "../../../API/ApiUser";
import { validateAccount } from "../../../utils/validateAccount";
import BarChartUtils from "../../../utils/barChart";
import { withTranslation } from "react-i18next";

import styles from "./accountStyles";
import AccountView from "./accountView";
import ApiPayments from "../../../API/ApiPayments";
import ApiGameAnalytics from "../../../API/ApiGameAnalytics";

class Account extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAdmin: false,
      isAdminSet: false,
      showError: false,
      dialogWaringOpened: false,
      deleteAccountDialogOpened: false,
      deleteAccountConfirmText: "",
      errorMessage: "",
      showSuccess: false,
      successMessage: "",
      accountLoaded: false,
      isDisableToursOpened: false,
      isStripeConnectLoading: false,
      commissionInvoices: [],
      commissionInvoicesLoading: true,
      downloadingInvoiceId: null,
      account: {
        aiCredits: 0,
        firstName: "",
        lastName: "",
        company: "",
        email: "",
        phoneNumber: "",
        createdAt: "",
        streetAddress: "",
        city: "",
        zipCode: -1,
        siret: "",
        maxNbOfTours: null,
        maxSessionsPerMonth: null,
        maxZones: null,
        maxEnigmas: null,
        role: null,
        secretCode: "",
        codeAmin: "",
        stripeCustomerId: null,
        setDisabledToursAt: null,
        maxSessionsPerMonth: -1,
        limitSessionPerMonth: -1,
        analyticsCountMonth: null,
        analyticsCountMonthReinitialize: null,
        userAskedCreationAccountStripeConnect: false,
        accountStripeConnectAuthorized: false,
        accountStripeConnectRejected: false,
        accountStripeConnectActive: false,
      },
    };

    this.submitForm = this.submitForm.bind(this);
    this.updateForm = this.updateForm.bind(this);
    this.updateMonthOffset = this.updateMonthOffset.bind(this);
    this.onCancelSubscription = this.onCancelSubscription.bind(this);
    this.getCustomerPortalSession = this.getCustomerPortalSession.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.openDeleteAccountDialog = this.openDeleteAccountDialog.bind(this);
    this.closeDeleteAccountDialog = this.closeDeleteAccountDialog.bind(this);
    this.updateDeleteAccountConfirmText = this.updateDeleteAccountConfirmText.bind(this);
    this.onDeleteAccount = this.onDeleteAccount.bind(this);
    this.openDeactivatedTours = this.openDeactivatedTours.bind(this);
    this.isButtonDeactivatedToursDisabled =
      this.isButtonDeactivatedToursDisabled.bind(this);
    this.getDateButtonToursDisabledReactivate =
      this.getDateButtonToursDisabledReactivate.bind(this);
    this.handleSubscriptionSelect = this.handleSubscriptionSelect.bind(this);
    this.resetErrorAlert = this.resetErrorAlert.bind(this);
    this.resetSuccessAlert = this.resetSuccessAlert.bind(this);
    this.handleStripeConnectSignup = this.handleStripeConnectSignup.bind(this);
    this.handleGoToStripeConnectAccount =
      this.handleGoToStripeConnectAccount.bind(this);
    this.handleDownloadCommissionInvoice =
      this.handleDownloadCommissionInvoice.bind(this);
  }

  componentDidMount() {
    document.title = "Mon compte | Landing Zone";

    this.setStateIsAdmin();
    this.getAccount();
    this.getSessionStatus();
    this.onPlanUpdated();
    this.hasRequestedStripeConnectAccount();
    this.hasRequestedStripeConnectAccountForTours();
    this.getCommissionInvoices();
  }

  async getCommissionInvoices() {
    const response = await ApiPayments.getCommissionInvoices();

    this.setState((prevState) => ({
      ...prevState,
      commissionInvoices:
        response.status === 200 && Array.isArray(response.data)
          ? response.data
          : [],
      commissionInvoicesLoading: false,
    }));
  }

  async handleDownloadCommissionInvoice(invoiceId) {
    const { t } = this.props;

    this.setState((prevState) => ({
      ...prevState,
      downloadingInvoiceId: invoiceId,
    }));

    const response =
      await ApiPayments.getCommissionInvoiceDownloadUrl(invoiceId);

    if (response.status === 200 && response.data?.url) {
      // L'URL signée expire en 5 minutes : on l'ouvre tout de suite.
      window.open(response.data.url, "_blank", "noopener,noreferrer");
      this.setState((prevState) => ({
        ...prevState,
        downloadingInvoiceId: null,
      }));
      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      downloadingInvoiceId: null,
      showError: true,
      showSuccess: false,
      errorMessage: t("commission_invoices.error.download_failed"),
    }));
  }

  openDeactivatedTours(value) {
    this.setState(
      (prevState) => ({
        ...prevState,
        isDisableToursOpened: false,
      }),
      () => {
        this.setState((prevState) => ({
          ...prevState,
          isDisableToursOpened: value,
        }));
      }
    );
  }

  closeDialog() {
    this.setState((prevState) => ({
      ...prevState,
      dialogWaringOpened: false,
    }));
  }

  openDialog() {
    this.setState((prevState) => ({
      ...prevState,
      dialogWaringOpened: true,
    }));
  }

  openDeleteAccountDialog() {
    this.setState((prevState) => ({
      ...prevState,
      deleteAccountDialogOpened: true,
      deleteAccountConfirmText: "",
    }));
  }

  closeDeleteAccountDialog() {
    this.setState((prevState) => ({
      ...prevState,
      deleteAccountDialogOpened: false,
      deleteAccountConfirmText: "",
    }));
  }

  updateDeleteAccountConfirmText(event) {
    const value = event.target.value;
    this.setState((prevState) => ({
      ...prevState,
      deleteAccountConfirmText: value,
    }));
  }

  async onDeleteAccount() {
    const { t } = this.props;

    const res = await ApiUser.deleteAccount();
    if (res.status === 200) {
      await ApiUser.logout();
      this.props.history.push("/login");
    } else {
      const errorMessage =
        res.data?.errorCode === "ACTIVE_STRIPE_SUBSCRIPTION"
          ? t("delete_account.error_active_subscription")
          : t("delete_account.error");

      this.setState((prevState) => ({
        ...prevState,
        deleteAccountDialogOpened: false,
        deleteAccountConfirmText: "",
        showError: true,
        showSuccess: false,
        errorMessage,
      }));
    }
  }

  async onPlanUpdated() {
    const { t } = this.props;

    let planUpdated = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).planUpdated;

    if (planUpdated) {
      // Temps pour la webhook de passer si ce n'est pas déjà fais
      await new Promise((resolve) => setTimeout(resolve, 2000));
      this.getAccount();
      this.setState((prevState) => ({
        ...prevState,
        showError: false,
        showSuccess: true,
        successMessage: t("account_view.success.account_updated"),
        dialogWaringOpened: false,
      }));
    }
  }

  getPriceFromType(type) {
    switch (type) {
      case "decouverteMonth":
        return 69;
      case "aventureMonth":
        return 89;
      case "expertMonth":
        return 159;
      case "decouverteEngagement":
        return 299;
      case "aventureEngagement":
        return 399;
      case "expertEngagement":
        return 699;
      default:
        return 0;
    }
  }

  async sha256(message) {
    // encoder la chaîne en UTF-8
    const msgBuffer = new TextEncoder().encode(message);

    // hash du message avec SHA-256
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

    // convertir l'ArrayBuffer en tableau d'octets
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convertir les octets en chaîne hexadécimale
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
    return hashHex;
  }

  async getSessionStatus() {
    const { t } = this.props;

    let sessionId = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).stripe_session_id;

    if (sessionId) {
      const resStatus = await ApiPayments.getSessionStatus(sessionId);
      if (resStatus.status == 200) {
        if (resStatus.data.status === "complete") {
          // Evenement facebook
          fbq("track", "Purchase", {
            value: this.getPriceFromType(resStatus.data.subscriptionType),
            currency: "EUR",
            user_data: {
              em: this.sha256(resStatus.data.email),
              fn: this.sha256(resStatus.data.firstname),
              ln: this.sha256(resStatus.data.lastname),
            },
          });

          // Temps pour la webhook de passer si ce n'est pas déjà fais
          await new Promise((resolve) => setTimeout(resolve, 2000));
          this.getAccount();
          this.setState((prevState) => ({
            ...prevState,
            showError: false,
            showSuccess: true,
            successMessage:
              resStatus.data?.subscriptionType === "aiCredits"
                ? t("account_view.success.subscription_updated_ai_credits")
                : t("account_view.success.subscription_updated"),
            dialogWaringOpened: false,
          }));
        } else {
          this.setState((prevState) => ({
            ...prevState,
            showError: true,
            showSuccess: false,
            errorMessage: t("account_view.success.payment_failed"),
            dialogWaringOpened: false,
          }));
        }
      }
    }
  }

  async hasRequestedStripeConnectAccount() {
    const { t } = this.props;

    let requestedStripeConnectAccount = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).requested_stripe_connect_account;

    if (requestedStripeConnectAccount) {
      this.setState((prevState) => ({
        ...prevState,
        showError: false,
        showSuccess: true,
        successMessage: t("account_view.requested_stripe_connect_account"),
        dialogWaringOpened: false,
        duration: 6000,
      }));
    }
  }

  async hasRequestedStripeConnectAccountForTours() {
    const { t } = this.props;

    let requested_stripe_for_tours = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).requested_stripe_for_tours;

    if (requested_stripe_for_tours) {
      this.setState((prevState) => ({
        ...prevState,
        showError: false,
        showSuccess: true,
        successMessage: t("account_view.requested_stripe_for_tours"),
        dialogWaringOpened: false,
        duration: 6000,
      }));
    }
  }

  async hasConnectedStripeConnectAccount() {
    const { t } = this.props;

    let stripeConnectSuccess = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).stripeConnectSuccess;

    if (stripeConnectSuccess) {
      this.setState((prevState) => ({
        ...prevState,
        showError: false,
        showSuccess: true,
        successMessage: t("account_view.success.stripe_connect_created"),
        dialogWaringOpened: false,
        duration: 6000,
      }));
    }
  }

  async onCancelSubscription() {
    const res = await ApiPayments.cancelSubscription();
    const { t } = this.props;

    if (res.status == 200) {
      this.setState((prevState) => ({
        ...prevState,
        showError: false,
        showSuccess: true,
        successMessage: t("account_view.success.subscription_cancelled"),
        dialogWaringOpened: false,
      }));
    }
  }

  async getCustomerPortalSession() {
    const res = await ApiPayments.getCustomerPortalSession();

    if (res.status == 200) {
      window.location.href = res.data.redirectTo;
    }
  }

  async updateMonthOffset(event) {
    let target = event.target;
    let value = target.value;

    let analyticsDatasFormatted = await BarChartUtils.formatDatasChart(
      this.state.analyticsFromApi,
      this.state.tourNames,
      value
    );

    this.setState((prevState) => ({
      ...prevState,
      analytics: analyticsDatasFormatted,
      monthOffset: value,
    }));
  }

  async getAnalyticsCountMonth() {
    try {
      const res = await ApiGameAnalytics.getAnalyticsCountUserMonth(
        this.state.account.userId
      );
      if (res.status === 200) {
        const moment = require("moment");
        let formattedReinitializeDate = res.data.reinitializeDate
          ? moment(res.data.reinitializeDate)
              .add(1, "month")
              .format("DD/MM/YYYY")
          : "";

        this.setState((prevState) => ({
          ...prevState,
          account: {
            ...prevState.account,
            analyticsCountMonth: res.data.count,
            analyticsCountMonthReinitialize: formattedReinitializeDate,
          },
        }));
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getAccount() {
    const { t } = this.props;

    ApiUser.getAccount().then((response) => {
      console.log("response.data : ", response.data);
      if (response.status != 200 || !response.data) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          showSuccess: false,
          errorMessage: t("account_view.error.unknown_error"),
        }));

        return;
      }
      let address = ["", "", ""];
      if (response.data.address) {
        address = response.data.address.split(";");
      }
      if (!address) {
        this.setState((prevState) => ({
          ...prevState,
          showError: true,
          showSuccess: false,
          errorMessage: t("account_view.error.unknown_error"),
        }));

        return;
      }
      if (address.length != 3) {
        address.push("");
        address.push("");
      }

      const aiCredits =
        response.data.aiCredits.onAccountCreation +
        response.data.aiCredits.monthlySubscription +
        response.data.aiCredits.paid;
      this.setState(
        (prevState) => ({
          ...prevState,
          accountLoaded: true,
          account: {
            aiCredits: aiCredits,
            userId: response.data.id,
            firstName: response.data.firstname,
            lastName: response.data.lastname,
            company: response.data.companyName,
            phoneNumber: response.data.phoneNumber,
            createdAt: response.data.createdAt,
            streetAddress: address[0],
            city: address[1],
            zipCode: Number(address[2]) | 0,
            siret: response.data.companySiret,
            email: response.data.email,
            maxNbOfTours: response.data.maxTours,
            maxSessionsPerMonth: response.data.maxSessionsPerMonth,
            maxZones: response.data.maxZones,
            maxEnigmas: response.data.maxEnigmas,
            role: response.data.role,
            secretCode: response.data.secretCodeIPad,
            adminCode: response.data.adminCode,
            stripeCustomerId: response.data.stripeCustomerId,
            setDisabledToursAt: response.data.setDisabledToursAt,
            hasTrial: response.data.hasTrial,
            maxSessionsPerMonth: response.data.maxSessionsPerMonth,
            limitSessionPerMonth: response.data.limitSessionPerMonth,
            userAskedCreationAccountStripeConnect:
              response.data.stripeConnectUserInfos
                ?.userAskedCreationAccountStripeConnect,
            accountStripeConnectAuthorized:
              response.data.stripeConnectUserInfos
                ?.accountStripeConnectAuthorized,
            accountStripeConnectRejected:
              response.data.stripeConnectUserInfos
                ?.accountStripeConnectRejected,
            accountStripeConnectActive:
              response.data.stripeConnectUserInfos?.accountStripeConnectActive,
            stripeConnectUserId:
              response.data.stripeConnectUserInfos?.stripeConnectUserId,
          },
        }),
        () => {
          this.getAnalyticsCountMonth();
        }
      );
    });
  }

  isButtonUpdateDeactivatedToursDisabled() {
    if (this.state.account.setDisabledToursAt) {
      const disabledToursDate = new Date(this.state.account.setDisabledToursAt);
      const now = new Date();
      const differenceInDays =
        (now - disabledToursDate) / (1000 * 60 * 60 * 24);

      // Si la différence est inférieure à 7 jours, désactiver le bouton
      return differenceInDays < 7;
    }
    return false;
  }

  async submitForm(event) {
    event.preventDefault();

    this.updateProfile();
  }

  async updateProfile() {
    const { t } = this.props;

    // La raison sociale est facultative ici, comme à l'inscription : elle
    // n'est exigée que sur l'écran « identité légale de facturation ».
    if (
      !this.state.account.firstName ||
      this.state.account.firstName == "" ||
      !this.state.account.lastName ||
      this.state.account.lastName == ""
    ) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("account_view.error.missing_fields"),
        showSuccess: false,
        dialogWaringOpened: false,
      }));

      return;
    }

    try {
      validateAccount(
        "parameternotsent@gmail.com",
        // Le SIRET n'est plus saisi ici : il est validé sur l'écran
        // « identité légale de facturation ».
        null,
        this.state.account.phoneNumber,
        1,
        this.state.account.maxSessionsPerMonth,
        this.state.account.limitSessionPerMonth
      );
    } catch (err) {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: err.message,
        showSuccess: false,
        dialogWaringOpened: false,
      }));

      return;
    }

    // Adresse et SIRET ne partent plus d'ici : le back les ignore désormais
    // sur cette route, et l'écran « identité légale de facturation » en est
    // la source unique. La raison sociale, elle, reste modifiable.
    let response = await ApiUser.updateAccount(
      this.state.account.firstName,
      this.state.account.lastName,
      this.state.account.company,
      null,
      null,
      this.state.account.phoneNumber,
      this.state.account.limitSessionPerMonth
    );

    if (response.status == 200 && response.data) {
      this.setState((prevState) => ({
        ...prevState,
        showError: false,
        showSuccess: true,
        successMessage: t("account_view.success.account_updated"),
        dialogWaringOpened: false,
      }));
    } else {
      this.setState((prevState) => ({
        ...prevState,
        showError: true,
        errorMessage: t("account_view.error.unknown_error"),
        showSuccess: false,
        dialogWaringOpened: false,
      }));
    }
  }

  async setStateIsAdmin() {
    let response = await ApiUser.isAdmin();

    if (response.status == 200) {
      this.setState((prevState) => ({
        ...prevState,
        isAdmin: response.data.isAdmin,
      }));
    }
  }

  updateForm(event) {
    let target = event.target;
    let value = target.value;

    if (target.name == "zipCode") {
      value = Number(target.value);
    }

    this.setState((prevState) => ({
      ...prevState,
      account: {
        ...prevState.account,
        [target.name]: value,
      },
    }));
  }

  isButtonDeactivatedToursDisabled() {
    if (this.state.account.role === "NO_SUBSCRIBTION") {
      return true;
    }
    if (this.state.account.setDisabledToursAt) {
      const disabledToursDate = new Date(this.state.account.setDisabledToursAt);
      const now = new Date();
      const differenceInDays =
        (now - disabledToursDate) / (1000 * 60 * 60 * 24);

      // Si la différence est inférieure à 7 jours, désactiver le bouton
      return differenceInDays < 7;
    }
    return false;
  }

  getDateButtonToursDisabledReactivate() {
    if (this.state.account.setDisabledToursAt) {
      const currentDate = new Date(this.state.account.setDisabledToursAt);
      const newDate = new Date(currentDate);
      newDate.setDate(newDate.getDate() + 7);
      const day = String(newDate.getDate()).padStart(2, "0"); // Ajoute un zéro si nécessaire
      const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Les mois sont indexés de 0
      const year = newDate.getFullYear();

      return `${day}/${month}/${year}`;
    }
    return null;
  }

  handleSubscriptionSelect = async () => {
    const { i18n } = this.props;
    const userLanguage = i18n.language;

    let key = "aiCredits";
    let res = await ApiPayments.createCheckoutSession(key, userLanguage);
    if (res && res.status === 200) {
      window.location.href = res.data.redirectTo;
    }
  };

  resetErrorAlert() {
    this.setState((prevState) => ({
      ...prevState,
      showError: false,
      errorMessage: "",
    }));
  }

  resetSuccessAlert() {
    this.setState((prevState) => ({
      ...prevState,
      showSuccess: false,
      successMessage: "",
    }));
  }

  async handleStripeConnectSignup() {
    this.setState({ isStripeConnectLoading: true });
    try {
      const response = await ApiPayments.createStripeConnectAccount();
      console.log("response : ", response);
      if (response.data.url) {
        window.location.href = response.data.url;
      } else {
        console.log("Stripe Connect Signup Error : ", response.data.error);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la création du compte Stripe Connect:",
        error
      );
    } finally {
      // this.setState({ isStripeConnectLoading: false });
    }
  }

  async handleGoToStripeConnectAccount() {
    this.setState({ isStripeConnectLoading: true });

    try {
      const response = await ApiPayments.getStripeConnectAccount();
      if (response.status === 200 && response.data.url) {
        window.open(response.data.url, "_blank");
        this.setState({ isStripeConnectLoading: false });
      }
    } catch (error) {
      console.error(
        "Erreur lors de la récupération de l'URL Stripe Connect:",
        error
      );
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <>
        <AccountView
          {...this.props}
          state={this.state}
          updateForm={this.updateForm}
          submitForm={this.submitForm}
          updateMonthOffset={this.updateMonthOffset}
          closeDialog={this.closeDialog}
          openDialog={this.openDialog}
          onCancelSubscription={this.onCancelSubscription}
          getCustomerPortalSession={this.getCustomerPortalSession}
          isButtonUpdateDeactivatedToursDisabled={
            this.isButtonUpdateDeactivatedToursDisabled
          }
          isDisableToursOpened={this.state.isDisableToursOpened}
          openDeactivatedTours={this.openDeactivatedTours}
          isButtonDeactivatedToursDisabled={
            this.isButtonDeactivatedToursDisabled
          }
          getDateButtonToursDisabledReactivate={
            this.getDateButtonToursDisabledReactivate
          }
          handleSubscriptionSelect={this.handleSubscriptionSelect}
          resetErrorAlert={this.resetErrorAlert}
          resetSuccessAlert={this.resetSuccessAlert}
          handleStripeConnectSignup={this.handleStripeConnectSignup}
          handleGoToStripeConnectAccount={this.handleGoToStripeConnectAccount}
          openDeleteAccountDialog={this.openDeleteAccountDialog}
          closeDeleteAccountDialog={this.closeDeleteAccountDialog}
          updateDeleteAccountConfirmText={this.updateDeleteAccountConfirmText}
          onDeleteAccount={this.onDeleteAccount}
          handleDownloadCommissionInvoice={this.handleDownloadCommissionInvoice}
        />
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withTranslation()(Account)
);
